<script>
  import { inertia, page } from '@inertiajs/svelte';
  import { fade, slide } from 'svelte/transition';
  import Preview from './Preview.svelte';

  export let projects = [];
</script>

<div class="table">
  <div class="table__head">
    <div class="table__row flexbox v-c flexbox--full">
      <div class="col col-20">
        <p class="table__item">{$page.props.i18n.page.name}</p>
      </div>
      <div class="col col-30">
        <p class="table__item">{$page.props.i18n.page.service}</p>
      </div>
      <div class="col col-20">
        <p class="table__item">{$page.props.i18n.page.customer}</p>
      </div>
      <div class="col col-10">
        <p class="table__item">{$page.props.i18n.page.country}</p>
      </div>
      <div class="col col-20">
        <div class="table__item" />
      </div>
    </div>
  </div>

  <div class="table__body">
    {#each projects as project (project.id)}
      <div
        class="table__row project-item flexbox v-c flexbox--full"
        transition:fade
      >
        <div class="col col-20 col-m-full">
          <p class="table__item">{project.title}</p>
        </div>
        <div class="col col-30 col-m-full">
          <p class="table__item">{project.service}</p>
        </div>
        <div class="col col-20 col-m-full">
          <p class="table__item">{project.customer}</p>
        </div>
        <div class="col col-10 col-m-full">
          <p class="table__item">{project.country}</p>
        </div>
        <div class="col col-20 col-m-full">
          <div class="table__item">
            <div class="project-item__action">
              {#if project.view?.type == 'external'}
                <a
                  class="btn btn-outline btn-outline--portfolio btn-icon"
                  href={project.view.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${$page.props.asset_url}img/open-external.svg`}
                    width="15"
                    height="13"
                    alt="Open external"
                  />
                  <span>{$page.props.i18n.page.open_link}</span>
                </a>
              {:else if project.view?.type == 'internal'}
                <a
                  class="btn btn-outline btn-outline--portfolio btn-icon"
                  href={project.view.url}
                  use:inertia
                >
                  <i class="isax isax-arrow-right-3" />
                  <span>{$page.props.i18n.page.learn_more}</span>
                </a>
              {:else if project.view?.type == 'design'}
                <button
                  class="btn btn-outline btn-outline--portfolio btn-icon project-item__toggle"
                  class:open={project.open}
                  type="button"
                  on:click={() => {
                    project.open = !project.open;
                  }}
                >
                  <i class="isax isax-arrow-down-1" />
                  <span>{$page.props.i18n.page.view_design}</span>
                </button>
              {/if}
            </div>
          </div>
        </div>
        {#if project.view?.type == 'design'}
          <div class="col col-full">
            {#if project.open}
              <div
                class="project-item__dropdown"
                class:open={project.open}
                transition:slide
              >
                <div class="flexbox flexbox--grid">
                  {#if project.preview}
                    {#each project.preview as item}
                      <div class="col col-33">
                        <Preview preview={item} />
                      </div>
                    {/each}
                  {/if}
                </div>
              </div>
            {/if}
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  .table {
    @include resp-min('m') {
      border-bottom: 1px solid $light-border;
    }

    margin: 4rem 0 0;
    width: 100%;

    &__row {
      @include resp-min('m') {
        border-top: 1px solid $light-border;

        padding: 3rem 0;
      }
    }

    &__head {
      @include resp-max('m') {
        display: none;
      }
      color: var(--royal-light);
    }

    &__body {
      @include resp-max('m') {
        border-top: 1px solid $light-border;
      }
    }

    &__item {
      font-size: 1.6rem;
    }
  }

  .project-item {
    @include resp-max('xs') {
      gap: 0.5rem;
      text-align: center;
    }

    @include resp-max('m') {
      position: relative;
      padding: 3rem;
      border: 1px solid $light-border;
      border-top: unset;
    }

    &__action {
      @include resp-range('xs', 'm') {
        position: absolute;
        top: 50%;
        right: 3rem;

        transform: translateY(-50%);
      }
    }

    &__toggle {
      .isax {
        transition: transform 0.3s;
      }

      &.open {
        .isax {
          transform: rotate(180deg);
        }
      }
    }

    &__dropdown {
      width: 100%;

      padding: 4rem 2rem 1rem;
    }
  }
</style>
